import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.css'],
})
export class PhoneVerificationComponent implements OnDestroy {
  @Input() verificationId: string = '';
  @Output() verified = new EventEmitter<void>();

  form = new FormGroup({
    code: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern(/^\d{6}$/),
    ]),
  });

  loading = false;
  errorMessage = '';

  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    const code = this.form.value.code!;

    this.onboardingService
      .verifySms(this.verificationId, code)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading = false;
          this.verified.emit();
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Código incorrecto. Intentá nuevamente.';
          }
        },
      });
  }
}
